import React from 'react';

export default class Page6 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToCommunicateYourVision');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Think of opportunities in your current work or outside, where you
                                                can translate a plan into action,
                                                using the PEA model and approach.</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to think about which aspects you find easy
                                                or more difficult, then measure
                                                how you improve with practice, by asking for formal or informal
                                                comments and suggestions. This
                                                will help you to think about support that you may need moving
                                                forward.</p>
                                            <div className="border_subtitle">Gauge other people's approaches
                                            </div>
                                            <p>Ask colleagues or peers how they would describe an idea to a
                                                group. Do you know someone
                                                who's done a lot of this kind of thing? Ask them about their
                                                experiences; for example, what do
                                                they do that works well and what do they find particularly
                                                challenging? How have they improved
                                                their approach? What advice or support would they be able to
                                                provide?</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMotivateOthers')}
                                                        className="link_color task button-link-redirect">How to motivate others</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeAssertive')}
                                                        className="link_color task button-link-redirect">How to be assertive</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToCommunicateEffectively')}
                                                        className="link_color task button-link-redirect">How to communicate
                                                        effectively</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToManageYourImpact')}
                                                        className="link_color task button-link-redirect">How to manage your
                                                        impact</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToCreateTeamIdentity')}
                                                        className="link_color task button-link-redirect">How to create team
                                                        identity</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToGainBuyInAndCommitment')}
                                                        className="link_color task button-link-redirect">How to gain buy-in and
                                                        commitment</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDevelopStrategicLongTermGoals')}
                                                        className="link_color task button-link-redirect">How to develop strategic
                                                        long-term goals</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToMakeComplexIdeasSimpleClearAndConcise')}
                                                        className="link_color task button-link-redirect">How to make complex ideas
                                                        simple, clear and concise.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Duck, J. &amp; Fielding,
                                                    K. (2003). Leaders and their treatment of subgroups:
                                                    Implications for evaluations
                                                    of the leader and the superordinate group.<span
                                                        className="subtiltereg"> European Journal of Social Psychology,</span> 33,
                                                    387-401.</p></li>

                                                <li><p className="further_info_content">Haslam, S. &amp; Platow,
                                                    M. (2001). The link between leadership and followership: How
                                                    affirming social identity
                                                    translates vision into action.<span className="subtiltereg">  Personality and Social Psychology Bulletin,</span> 27,
                                                    1469-1479.</p></li>
                                                <li><p className="further_info_content">Dawkins, R. (2006).<span
                                                    className="subtiltereg">  The God Delusion.</span> Black
                                                    Swan.</p></li>
                                                <li><p className="further_info_content">Linley, P. &amp; Joseph,
                                                    S. (2004).<span className="subtiltereg"> Positive Psychology in Practice.</span> Wiley.
                                                </p></li>
                                                <li><p className="further_info_content">Rosenthal, R. and
                                                    Jacobson, L. (1968).<span className="subtiltereg"> Pygmalion in the Classroom.</span> New
                                                    York: Holt, Rhinehart,
                                                    and Winston.</p></li>
                                                <li><p className="further_info_content">Nadkarni, S. (2003).
                                                    Instructional methods and mental models of students.<span
                                                        className="subtiltereg"> Academy of Management
				Learning &amp; Education,</span> 2(4), 335-351.</p></li>


                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}